// Browser origins isolate complete native Web A storage, caches and broadcasts.
// This wrapper only binds the GramJS worker to its platform lease.
import { readContext } from './context';

let installed = false;
const ownedWorkers = new Set<Worker>();

export function installSandbox() {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  const context = readContext();
  const OriginalWorker = globalThis.Worker;
  globalThis.Worker = class ScopedWorker extends OriginalWorker {
    constructor(url: string | URL, options: WorkerOptions = {}) {
      const name = new URLSearchParams(options.name || '');
      name.set('tgready', JSON.stringify(context));
      super(url, { ...options, name: name.toString() });
      ownedWorkers.add(this);
    }
  };
}

export function stopSandbox() {
  ownedWorkers.forEach((worker) => worker.terminate());
  ownedWorkers.clear();
}

export async function purgePrivateData() {
  // Called before Web A starts, or on a fresh /ended page, so native IDB handles are closed.
  localStorage.clear();
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }
  if ('caches' in window) await Promise.all((await caches.keys()).map((key) => caches.delete(key)));
  const databases = await indexedDB.databases();
  await Promise.all(databases.filter((db) => db.name).map((db) => new Promise<void>((resolve, reject) => {
    const request = indexedDB.deleteDatabase(db.name!);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(new Error('无法清理该账号上一轮网页数据，请关闭其他同号标签后重试'));
    request.onblocked = () => reject(new Error('该账号网页数据仍被占用，请关闭其他同号标签后重试'));
  })));
}
